<div class="side-by-eaches" *ngIf="integration?.options">
    <div class="side-by-eaches-temp-input">
        <input name="ga4-id" type="text" [(ngModel)]="integration.options.measurementId" placeholder="GA4 ID" />
    </div>
    <div class="side-by-eaches-temp-action">
        <app-button (action)="updated.emit(integration)" [busy]="busy">Set</app-button>
    </div>
</div>
